import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "slide", "dot"]

  static values = {
    currentIndex: { type: Number, default: 0 },
  }

  currentIndexValueChanged() {
    this.updateSlides()
    this.updateDots()
  }

  changeSlide(event) {
    this.currentIndexValue = Array.from(this.dotTargets).indexOf(event.currentTarget)
  }

  updateSlides() {
    this.slideTargets.forEach((slide, index) => {
      if (index === this.currentIndexValue) {
        slide.classList.remove("opacity-0")
        slide.classList.add("opacity-100")
      } else {
        slide.classList.remove("opacity-100")
        slide.classList.add("opacity-0")
      }
    })
  }

  updateDots() {
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle("bg-zinc-950", index === this.currentIndexValue)
      dot.classList.toggle("bg-gray-100", index !== this.currentIndexValue)
    })
  }

  transitionEnd(event) {
    event.currentTarget.classList.add("hidden")

    const activeSlide = this.slideTargets[this.currentIndexValue]
    activeSlide.classList.remove("hidden")
    activeSlide.classList.remove("opacity-0")
  }
}
